import client from './client';

export const dietApi = {
  // Food log
  getLog: (date, clientId) =>
    client.get('/diet/log', { params: { date, client_id: clientId } }),
  addFood: (data) => client.post('/diet/log', data),
  removeFood: (id) => client.delete(`/diet/log/${id}`),

  // Weekly summary
  getWeeklySummary: (params) => client.get('/diet/weekly-summary', { params }),

  // Foods database
  searchFoods: (query, params) =>
    client.get('/foods/search', { params: { q: query, ...params } }),
  getFoodById: (id) => client.get(`/foods/${id}`),
  createFood: (data) => client.post('/foods', data),
  updateFood: (id, data) => client.put(`/foods/${id}`, data),
  deleteFood: (id) => client.delete(`/foods/${id}`),

  // FatSecret
  fatSecretSearch: (query, params) =>
    client.get('/foods/fatsecret/search', { params: { q: query, ...params } }),
  fatSecretBarcode: (barcode) =>
    client.get('/foods/fatsecret/barcode', { params: { barcode } }),
  fatSecretRecipes: (query) =>
    client.get('/foods/fatsecret/recipes', { params: { q: query } }),
  fatSecretImageRecognition: (imageData) =>
    client.post('/foods/fatsecret/image', { image: imageData }),

  // AI parsing for Quick Add card (text + optional image)
  parseMealWithAI: ({ description, imageData, language }) =>
    client.post('/diet/ai-parse-meal', {
      description: description || '',
      image_data: imageData || '',
      language: language || 'en',
    }),

  // Quick meals (templates)
  getQuickMeals: () => client.get('/meal-templates'),
  createQuickMeal: (data) => client.post('/meal-templates', data),
  updateQuickMeal: (id, data) => client.put(`/meal-templates/${id}`, data),
  deleteQuickMeal: (id) => client.delete(`/meal-templates/${id}`),

  // Diet plans (coach-assigned)
  getPlans: (clientId) =>
    client.get('/diet-plans', { params: { client_id: clientId } }),
  createPlan: (data) => client.post('/diet-plans', data),
  updatePlan: (id, data, sessionId) => client.put(`/diet-plans/${id}${sessionId ? `?session_id=${encodeURIComponent(sessionId)}` : ''}`, data),
  deletePlan: (id) => client.delete(`/diet-plans/${id}`),

  // Diet plan version history + Trash
  listPlanVersions: (id) => client.get(`/diet-plans/${id}/versions`),
  getPlanVersion: (id, n) => client.get(`/diet-plans/${id}/versions/${n}`),
  restorePlanVersion: (id, n) => client.post(`/diet-plans/${id}/versions/${n}/restore`),
  listDeletedPlans: () => client.get('/diet-plans/deleted'),
  restoreDeletedPlan: (id) => client.post(`/diet-plans/deleted/${id}/restore`),

  // Diet suggestions
  getSuggestions: (clientId) =>
    client.get('/diet-suggestions', { params: { client_id: clientId } }),
  createSuggestion: (data) => client.post('/diet-suggestions', data),
  updateSuggestion: (id, data) => client.put(`/diet-suggestions/${id}`, data),
  dismissSuggestion: (id) => client.delete(`/diet-suggestions/${id}`),
};
